import { Offer, PaymentOption, Time } from "@models";
import { BpSelectorFrequencyModel } from "../modules/core/components/bp-selector-frequency/selector-models/bp-selector-frequency-model";
import { SavingsPlan } from "@models/savings_plan";
import { SavingsPlanExample } from "@models/savings_plan_example";
import moment from "moment";

export class SavingsModel {
	private _paymentOption: PaymentOption;
	private _frequencySelector: BpSelectorFrequencyModel = new BpSelectorFrequencyModel();
	private _paymentPlan: SavingsPlan;
	private _planExample: SavingsPlanExample = new SavingsPlanExample();
	private _initialBuy: Time = new Time();
	private _tradeDataModel: Offer; // This.data model belongs to Trade interface

	private _limitsExceeded: boolean = false;

	private readonly defaultFormat = "dddd, MMMM Do YYYY, HH:mm";

	public get paymentPlan(): SavingsPlan {
		return this._paymentPlan;
	}

	public set paymentPlan(m: SavingsPlan) {
		this._paymentPlan = m;
	}

	public get planExample(): SavingsPlanExample {
		return this._planExample;
	}

	public set planExample(p: SavingsPlanExample) {
		this._planExample = p;
	}

	public get frequencySelector(): BpSelectorFrequencyModel {
		return this._frequencySelector;
	}

	public set frequencySelector(m: BpSelectorFrequencyModel) {
		this._frequencySelector = m;
	}

	public get paymentOption(): PaymentOption {
		return this._paymentOption;
	}

	public set paymentOption(p: PaymentOption) {
		this._paymentOption = p;
	}

	public get initialBuy(): Time {
		return this._initialBuy;
	}

	public set initialBuy(t: Time) {
		this._initialBuy = t;
	}

	public get tradeData(): Offer {
		return this._tradeDataModel;
	}

	public set tradeData(m: Offer) {
		this._tradeDataModel = m;
	}

	public get limitsExceeded(): boolean {
		return this._limitsExceeded;
	}

	public set limitsExceeded(b: boolean) {
		this._limitsExceeded = b;
	}

	public getTimeZone(): string {
		return Intl.DateTimeFormat().resolvedOptions().timeZone;
	}

	public getInitialBuyFormatted(fromView: boolean = false, formatType: string = this.defaultFormat): string {
		const time: Time = fromView ? this.planExample.getNextAt() : this.initialBuy;
		return this.getFormattedTime(time, formatType);
	}

	public getNextBuyFormatted(formatType: string = this.defaultFormat): string {
		if (this.planExample) {
			return this.getFormattedTime(this.planExample.getNextAt(), formatType);
		}
		return "";
	}

	private getFormattedTime(time: Time, formatType): string {
		if (formatType === this.defaultFormat) {
			return moment(time.getDate()).format(this.defaultFormat);
		}
		return "";
	}

	public getSummaryFrequency(): string {
		if (!this.frequencySelector) {
			return "";
		}

		const mainFrequency = this.frequencySelector.primaryName;
		const secFrequency = this.frequencySelector.secondaryNumber ? this.frequencySelector.secondaryNumber : "";
		const timeFrequency = this.frequencySelector.time;

		return mainFrequency + ", " + (secFrequency ? secFrequency + ", " : "") + timeFrequency;
	}
}
